<template>
    <div class="unregister-page" v-if="isLoadingCheck">

        <div class="header">
            ติดต่อเรา
        </div>
        <div class="info-wrapper" >
            <div>หากต้องการติดต่อลูกค้าสัมพันธ์ </div>
            <div @click="clickTracking('click_contact_phone')"><a href="tel:025088995">โทร <span> (66) 25088995</span></a></div>
            <div>หรืออีเมล กรุณาคลิกด้านล่าง</div>

            <div @click="clickTracking('click_contact_mail')" class="btn btn-email">
                <a href="https://services.chanel.com/th_TH/contact?_gl=1*gt4f7v*_ga*MTUyODU4MDEzNy4xNjE0ODQwNjE0*_ga_FNK4X913R4*MTYxNTM2ODMzNC4zLjEuMTYxNTM2ODMzOS4w">อีเมล</a>
            </div>

            <div class="close-chanel">
                <div>กลับไปที่ CHANEL LINE ACCOUNT</div>
                <div @click="openLineChanel()" class="click">คลิก</div>
            </div>
        </div>
        <div class="unregister-footer" v-if="isEnableUnsub">
            <div>ยกเลิกการลงทะเบียนกับ Chanel Line Business Account</div>
            <div class="unregister" @click="clickUnSubScribe()">คลิก</div>

        </div>
        <modal view="campaign-list"
            :busModal="busModal"
            @modalConfirmOk="clickConfirm"
            @modalConfirmCancel="clickCancel"
        ></modal>

        <modal-delete-account
            :busModal="busModalDeleteAccount"

        ></modal-delete-account>
        <modal-error :busModal="busModalError"></modal-error>

    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

import Vue from "vue";

import Locale from "@/helper/locale/locale.js";
import Account from "@/helper/AccountHelper.js";
// import TopBar from "@/components/TopBar.vue";

import Modal from "@/components/modal/Modal.vue";
import ModalDeleteAccount from "@/components/modal/ModalDeleteAccount.vue";
import ModalError from "@/components/modal/ModalError.vue";
import { TrackingService } from "@/helper/TrackingHelper.js";
import BzbsApi from "@/service/BzbsApi.js";
import Util from "@/helper/Utility.js"

export default {
    name: "unregister",
    components: {
        // TopBar,
        Modal,
        ModalError,
        ModalDeleteAccount,
    },
    data: function() {
        return {

            isLogin: false,
            profile: {},
            lbl: Locale.getLbl(),
            startFlow: true,
            textInfo:'',

            busModal: new Vue(),
            busModalError: new Vue(),
            busModalDeleteAccount: new Vue(),

            tracking: new TrackingService(this),
            isEnableUnsub: false,
            isLoadingCheck: false,
        };
    },
    created: async function() {

        if (await this.checkMaintenance()) {
            console.log("checkMaintenance TRUE")
            return
        }
        console.log("Create")
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            if (status) {
                this.profile = Account.getCacheProfile();
            }
        });


		this.tracking.screenName("Unregis_flow");
        this.tracking.event("Unregis_flow", "view_contact_page");

        this.getConfigUnsub()
        // Vue.ga.screenName(this, 'Home');
        // Vue.ga.event(this, "new cat", "view page", "home label");

    },
    methods: {
        switchLang: function(locale) {
            Account.apiUpdateProfileLocale(locale)
                .then(profile => {
                    if (profile)
                        this.profile = profile;

                    Locale.setLocale(locale);
                    this.lbl = Locale.getLbl();
                })
                .catch(() => {});
        },
        login: function() {
            Account.apiBzbsLogin(this.modelLogin.username, this.modelLogin.password)
                .then(objResult => {
                    this.isLogin = true;
                    this.profile = objResult.profile;
                    console.log(objResult);
                })
                .catch(error => {
                    console.log(error);
                });
        },

        logout: function() {
            Account.setLogout();
            this.isLogin = false;
            this.profile = {};
        },
        clickConfirm: function (objConfirm) {
            this.tracking.event("Unregis_flow", "click_confirm_unregis_botton");
            switch (objConfirm.tag) {
                case "confirm-delete":
                Account.apiUnSubScribe()
                    .then((objResult) => {
                        if (objResult.data && objResult.data.success) {
                            Account.removeCacheUser();
                            this.busModalDeleteAccount.$emit("showModal");
                        } else {
                            console.log(objResult);
                        }
                    })
                    .catch((error) => {
                        if (error.response) {
                            console.log(error.response.data);
                            this.busModalError.$emit("showModal");
                        } else {
                            this.busModal.$emit(
                            "showAlertModal",
                            this.$configModalNoConnect
                            );
                        }
                    });

                break;
            }
        },
        clickCancel: function () {
            this.tracking.event("Unregis_flow", "click_unconfirm_unregis_botton");
        },
        clickTracking: function (eventTrack) {

            this.tracking.event("Unregis_flow", eventTrack);
        },
        clickOkModalConfirm: function () {

            Account.apiUnSubScribe()
                .then((objResult) => {
                    if (objResult.data && objResult.data.success) {
                        Account.removeCacheUser();
                        this.startFlow = false;
                    } else {
                        console.log(objResult);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    // if (error.response) {

                    //     console.log(error.response.data);
                    //     this.busModalError.$emit("showModal");
                    // } else {
                    //     this.busModal.$emit(
                    //     "showAlertModal",
                    //     this.$configModalNoConnect
                    //     );
                    // }
            });
        },
        clickCancelModalConfirm: function () {

            if (Account.getCacheCustom("Formliff")) {

                window.lineFunction.closewindow();

            }
        },
        clickUnSubScribe: function () {

            this.tracking.event("Unregis_flow", "click_unregis_botton");

            this.busModal.$emit("showConfirmModal", {
                title: "ยกเลิกการลงทะเบียน",
                message:
                "คุณต้องการยกเลิก<br> การลงทะเบียนกับ CHANEL",
                strBtnOk: "ใช่",
                strBtnCancel: "ไม่ใช่",
                tag: "confirm-delete",
            });
        },
        hideModal: function () {
            this.$router.push('/register');
        },

        openLineChanel: function () {

            var url = Vue.bzbsConfig.linkLineChanel;
            window.open(url);
        },
        getConfigUnsub: function () {
            console.log("getConfigUnsub")

			var strUrl = Vue.bzbsConfig.bzbsBlobUrl + "/webconfig/ChanelFashion/config/configCancelMember.json";
            console.log("blob strUrl",strUrl)
			return new Promise(() => {
				BzbsApi.connectBzbsBlob(strUrl)
                    .then((response) => {
                        this.isEnableUnsub = response.data.isEnable;
                        console.log("isEnableUnsub", this.isEnableUnsub)
                    })
                    .catch((error) => {
                        console.log(error);
                    });
			});
        },
        checkMaintenance: function () {
            return new Promise((resolve) => {
                console.log("checkMaintenance")
                let StartDateMaintenance = window.StartDateMaintenance;
                let EndDateMaintenance = window.EndDateMaintenance;

                // StartDateMaintenance = "2024-02-19 15:00:00"
                // EndDateMaintenance = "2024-04-22 12:00:00"
                if (Util.isEmptyStr(StartDateMaintenance) || Util.isEmptyStr(EndDateMaintenance)) {
                    this.isLoadingCheck = true;
                    console.log("checkMaintenance ISEMPTY")
                    resolve(false);
                } else {
                    var stDate = new Date(StartDateMaintenance)
                    var edDate = new Date(EndDateMaintenance)
                    var today = new Date()
                    if ( today > stDate && today < edDate)
                    {
                        window.location.replace('/maintenance');
                        resolve(true);
                    }
                    this.isLoadingCheck = true;
                    resolve(false);
                }
            });
        }

    },
};
</script>
<style lang="scss" scoped>

.unregister-page {
    padding: 0 10px 10px 10px;

    .header {
        padding-top: 60px;
        text-align: center;
        font-weight: bold;
        font-size: 1.5rem;
    }
    .info-wrapper{
        text-align: center;
        font-family: 'semibold';
        padding-top: 60px;
        a {
            color: #000000;
            text-decoration: none;
            background-color: transparent;

            span {
                text-decoration: underline;
            }
        }

        .close-chanel {
            text-align: center;
            font-size: 0.8rem;
            color: #262626;
            margin-top: 25px;

            .click {
                margin-top: 5px;
                text-decoration: underline;
            }
        }

        .btn-email {

            margin-top: 40px;
            border: solid 1px #000000;
            border-radius: 0px;
            padding-bottom: 10px;
        }
    }
    .unregister-footer {
        width: 100%;
        text-align: center;
        position: fixed;
        bottom: 20px;
        font-size: 11px;

        .unregister {
            text-decoration: underline;
        }
    }
    // .unregister-wrapper {
    //     background-color: white;
    //     min-height: 91vh;
    //     display: flex;

    //     .unregis-content {

    //         margin: auto;
    //         margin-top: 180px;
    //         padding: 20px;

    //         .header{
    //             text-align: center;
    //             font-size: 1.2rem;
    //             text-decoration: underline;
    //             margin-bottom: 1rem;
    //         }
    //         .message {
    //             text-align: center;
    //             margin-bottom: 1rem;

    //         }
    //     }
    // }
    // .unregister-success {
    //     min-height: 91vh;
    //     display: flex;

    //     .unregis-content {

    //         margin: auto;
    //         margin-top: 180px;
    //         padding: 20px;

    //         .img-delete-account {
    //             max-width: 120px;
    //             margin: auto;

    //         }
    //         .modal-msg {
    //             text-align: center;
    //             padding: 20px;
    //             font-size: 1.1rem;
    //             color: white;
    //         }
    //         .wrap-btn-close {
    //             max-width: 150px;
    //             margin: auto;
    //         }
    //     }

    // }
}

</style>
